<template>
    <table-base :filter="filter" :headers="headers" :api-data="apiData" :sorting="sorting" :items-field="itemsField" :edit-page-name="editPageName" :api-method="apiMethod" :claim-name="claimName" :form-title="formTitle" :excel-title="excelTitle" :has-edit-page="hasEditPage" :table-form="harvestingForm" :refresh-key="refreshKey" :show-expand="$route.name == 'auditEditor'" :has-import="true">
        <template v-slot:expand="{ item, refreshKey }">
            <component :is="harvesting" v-if="$route.name == 'auditEditor'" :item-id="item.id" :refresh-key="refreshKey" :filter="filter" />
        </template>
    </table-base>
</template>

<script>
    export default {
        props: [
            'filter',
            'refreshKey'
        ],
        components: {
            tableBase: () => import('../components/TableBase'),
        },
        data() {
            return {
                harvestingForm: () => import('../forms/HarvestingForm'),
                harvesting: () => import('../editViews/Harvesting'),
                headers: [
                    { text: 'On', value: 'on', format: this.formatDate },
                    { text: 'Facility', value: 'facilityId', table: 'facilities', form: () => import('../forms/FacilityForm') },
                    { text: 'Load', value: 'loadId', table: 'loads', form: () => import('../forms/LoadForm') },
                    { text: 'Number Of Frames', value: 'numberOfFrames' },
                    { text: '', value: 'action' }
                ],
                apiData: {
                    facilities: [],
                    loads: [],
                    items: []
                },
                sorting: [
                    { column: "on", direction: "descending" },
                    { column: "facilityId", direction: "ascending" },
                    { column: "loadId", direction: "ascending" },
                ],
                itemsField: 'harvestings',
                editPageName: 'harvesting',
                apiMethod: 'Harvestings',
                claimName: 'Harvestings',
                formTitle: 'Harvesting',
                excelTitle: 'Harvestings',
                hasEditPage: true,
            }
        },
    };
</script>
